import PlayAudioIcon from '../../../../../ui/svg/audio/play-audio';
import StopAudioIcon from '../../../../../ui/svg/audio/stop-audio';
import React from 'react';
import { rootActions, useAppDispatch, useAppSelector } from '../../data/store';
import { play, stop  } from '../../domain/audio-provider';

const PlayStopBtn = () => {

    const dispatch = useAppDispatch();

    const isPlaying = useAppSelector(store => store.root.isPlaying);
    const isBypass = useAppSelector(store => store.root.isBypass);
    const isDelta = useAppSelector(store => store.root.isDelta);
    const selected = useAppSelector(store => store.root.selected);
    const audioContext = useAppSelector(store => store.root.audioContext);

    const data = useAppSelector(store => store.root.data);
    const activeColor = data?.settings?.activeColor || '#E29E39';

    const toggle = () => {
       if(isPlaying) {
           stop(selected, isBypass, isDelta);

           dispatch(
               rootActions.main({
                   isPlaying: false,
               })
           );
       }
       else{
           const _selected = play(audioContext, selected, isBypass, isDelta);

           dispatch(
               rootActions.main({
                   selected: _selected,
                   isPlaying: true,
               })
           );
       }
    };

    return (
        <button
            type="button"
            className={ `w-btn ${ isPlaying ? 'bg-blue-d9dfff' : 'bg-gray-200' } rounded-full w-32 p-2 mt-0 md:mt-0 lg:mt-0 md:text-lg text-gray-700 flex flex-row items-center justify-center mr-6` }
            style={{
                backgroundColor: activeColor,
            }}
            onClick={ toggle }>
            {
                !isPlaying &&
                <PlayAudioIcon
                    width="20"
                    height="20"
                    color="#ffffff"
                    bgColor="#000000"
                />
            }
            {
                isPlaying &&
                <StopAudioIcon
                    width="20"
                    height="20"
                    color="#ffffff"
                    bgColor="#000000"
                />
            }
            <span className="pl-2">{ isPlaying ? 'Stop' : 'Play'}</span>
        </button>
    )
};

export default PlayStopBtn;